import { FunctionComponent } from 'react'
import Modal from '@/components/Modal'
import { Button } from '@conexasaude/hero'
import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import useStyles from './styles'
const CallStartedModal: FunctionComponent<{
  hookSuccess()
}> = ({ hookSuccess }) => {
  const { closeModal } = useModalContext()
  const {
    realtimeAttendance: { call },
  } = useRealtimeAttendanceContext()
  const { container } = useStyles()
  return (
    <Modal id="CALL_STARTED">
      <div css={container}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <p className="w-100 mb-5">
            <span className="highlight">{call?.professionalName}</span> já está
            aguardando por você. Vamos começar?
          </p>
          <div className="d-flex justify-content-end flex-lg-row flex-column-reverse w-100 footer-modal-buttons">
            <Button
              id="SalaDeEsperaImediata-IniciarConsulta-CTA_IniciarConsulta"
              onClick={() => {
                closeModal()
                hookSuccess()
              }}
            >
              Iniciar consulta
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default CallStartedModal
